import { metricResultsMock } from '../mockData/metricResults';
import { metricResultsL2Mock } from '../mockData/metricResults/l2';
import { insightResultsMock } from '../mockData/insightResults';
import type { Filters, InsightResult, MetricDataLevel, MetricFetchResult } from '../types';
import { TILE_EMPTY_STATUS_CODE } from '../utils/tileFetchError';

const delay = (ms = 120) => new Promise(resolve => setTimeout(resolve, ms));

/** Overview tiles used to preview the grey 204 empty card in mock mode. */
const MOCK_EMPTY_METRIC_IDS = new Set(['conversion_rate', 'oldest_lead_days_to_revival']);

export default class MetricsFrameworkMockService {
  static async getMetric(
    id: string,
    _filters: Filters,
    dataLevel: MetricDataLevel = 'L1',
  ): Promise<MetricFetchResult> {
    await delay();

    if (MOCK_EMPTY_METRIC_IDS.has(id)) {
      const data = metricResultsMock[id];
      if (!data) {
        throw new Error(`Unknown metric: ${id}`);
      }
      return { data, statusCode: TILE_EMPTY_STATUS_CODE };
    }

    if (dataLevel === 'L2') {
      const l2 = metricResultsL2Mock[id];
      if (l2) return { data: l2, statusCode: 200 };
    }

    const result = metricResultsMock[id];
    if (!result) {
      throw new Error(`Unknown metric: ${id}`);
    }
    return { data: result, statusCode: 200 };
  }

  static async getInsight(id: string, _filters: Filters): Promise<InsightResult> {
    await delay();
    const result = insightResultsMock[id];
    if (!result) {
      throw new Error(`Unknown insight: ${id}`);
    }
    return result;
  }
}
